export function slugError(message, slug, data) {
    return errorToSlugError(new Error(message), slug, data);
}
export function errorToSlugError(error, slug, data) {
    const sluggedError = error;
    sluggedError.slug = `sdkshop.log.${slug.join('.')}`;
    if (data) {
        sluggedError.slugData = data;
    }
    return sluggedError;
}
//# sourceMappingURL=errors.js.map